<template>
    <multiselect
        v-model="cnae"
        :options="activeCnaes"
        track-by="uuid"
        label="activity"
        :custom-label="customLabel"
        :multiple="false"
        :allowEmpty="true"
        placeholder="Actividad CNAE"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange">
            <template slot="noOptions">Cargando...</template>
        </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';

    export default {
        name: "CnaeSelector",
        components: {
            Multiselect
        },
        props: {
            value: Object
        },
        data: function () {
            return {
                cnae: null
            }
        },
        mounted() {
            this.$store.dispatch('loadCnaes');
            this.cnae = this.evaluateValue(this.value);
        },
        computed: {
            ...mapGetters([
                'activeCnaes'
            ])
        },
        methods: {
            evaluateValue(value) {
                if (
                    !!value
                    && !!value.uuid
                    && !!this.findCnaeByUuid(value.uuid)
                ) {
                    return this.findCnaeByUuid(value.uuid);
                } else {
                    return null;
                }
            },
            findCnaeByUuid(uuid) {
                return this.activeCnaes.find(cnae => (cnae.uuid === uuid));
            },
            notifyChange(cnae) {
                this.$emit('input', cnae);
            },
            customLabel ({ code, activity }) {
                return `${code} - ${activity}`
            }
        },
        watch: {
            value: function () {
                this.cnae = this.evaluateValue(this.value);
            },
            activeCnaes: function () {
                this.cnae = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>